import React from "react";
import View from "./View";
import {useUtilData} from "../../hooks/useUtilData";


export default function PartView(props){
    const utilsLoaded = useUtilData({department: 1, payment_type: 1, make: 1, model: 1, nominal: 1, tracking: 1, type: 1});

    return (
        <View loaded={utilsLoaded} {...props}/>
    )

}